<template>

  <div>
    <EmpresaEnergyView :guid="guid" v-if="tenantType === 'ENERGY'"/>

    <EmpresaFinanceView :guid="guid" v-if="tenantType === 'FINANCE'"/>
  </div>

</template>

<script>
import EmpresaEnergyView from '@/views/balance/EmpresaEnergyView'
import EmpresaFinanceView from '@/views/balance/EmpresaFinanceView'
import UserAuthorization from "@/mixins/UserAuthorization";
import axios from "axios";

export default {
  mixins:[UserAuthorization],
  props: {
    guid: String
  },
  components: {
    EmpresaEnergyView,
    EmpresaFinanceView,
  },
  data () {
    return {
      tenantType: null,
    }
  },
  beforeMount() {
    this.loadTenantType()
  },
  methods: {
    loadTenantType() {
      axios.get(`${process.env.VUE_APP_API}/api/v1/tenant-type`)
        .then((response) => {
          this.tenantType = response.data
        })
    }
  }
}
</script>

<style scoped>

</style>
